module.exports = __webpack_public_path__ + "3b1881b93f5637a35c2f5ff90976bc64.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201610_dnn.jpg
// module id = 649
// module chunks = 0